import { cn } from '@/lib/utils';
import React from 'react';
interface IconProps {
    text: string;
    className?: string;
    className2?: string;
}

const UnderlineHeading = ({ text, className, className2 }: IconProps) => {
    return (
        <div className={cn('border-b border-primery-blue-900 text-primery-blue-900 pb-[5.5px] w-fit', className2)}>
            <h2
                className={cn('font-cairo font-bold md:text-[22px] sm:text-[20px] text-[18px] leading-[33px] tracking-normal text-center', className)}
            >
                {text}
            </h2>
        </div>
    );
};

export default UnderlineHeading;
